<section class="not-found">
  <div class="not-found__card">
    <div class="not-found__code">404</div>
    <h1>{{ 'COMMON.NOT_FOUND_TITLE' | translate }}</h1>
    <p>{{ 'COMMON.NOT_FOUND_DESCRIPTION' | translate }}</p>
    <button type="button" class="not-found__button" (click)="goHome()">
      {{ 'COMMON.GO_HOME' | translate }}
    </button>
  </div>
</section>
